<template>
  <v-dialog
    :value="active"
    persistent
    transition="dialog-bottom-transition"
    style="z-index: 2000"
    :fullscreen="true"
    :scrollable="true"
  >
    <v-card
      class="text-center"
      :class="
        getTheme() == 'dark' ? 'outlined elevation-0' : 'flat elevation-0'
      "
      :style="getTheme() == 'dark' ? '' : 'border-bottom: 1px solid lightgray'"
    >
      <v-card-title
        :style="
          getTheme() == 'dark'
            ? 'background-color: #505050'
            : 'background-color: white; border-bottom: 1px solid lightgray'
        "
        :class="getTheme() == 'dark' ? 'white--text' : '#505050--text'"
        class="title font-weight-regular pl-5 pr-3"
      >
        <v-icon
          :class="getTheme() == 'dark' ? 'white--text' : 'primary--text'"
          class="mr-2"
          medium
          >mdi-image-multiple</v-icon
        >
        <span v-show="$vuetify.breakpoint.smAndUp">{{
          $t("fabricSelectImageBackgoundDialogTitle")
        }}</span>
        <v-spacer></v-spacer>
        <a href="https://www.pixabay.com" target="_blank"
          ><v-img style="max-width: 150px" :src="pixabayLogo"> </v-img
        ></a>
        <v-spacer></v-spacer>
        <v-btn
          text
          medium
          @click="active = false"
          style="min-width: 0; width: 20px"
        >
          <v-icon
            medium
            :class="getTheme() == 'dark' ? 'white--text' : 'primary--text'"
            >mdi-close</v-icon
          >
        </v-btn>
      </v-card-title>
      <v-card-title class="my-0 py-0">
        <v-flex xs12>
          <v-text-field
            clearable
            v-model="search"
            @keyup.enter="loadPixabayBackgrounds(true)"
            append-icon="mdi-magnify"
            :label="$t('dataGridPixabaySearchLabel')"
            single-line
            hide-details
            @click:append="loadPixabayBackgrounds(true)"
            @click:clear="resetSearch"
          ></v-text-field>
        </v-flex>
        <v-flex xs6 md3>
          <v-select
            class="pa-0 ma-0 mt-2 ml-1"
            style="height: 30px"
            v-model="imageCategory"
            :items="imageCategorys"
            item-text="title"
            item-value="query"
            @change="loadPixabayBackgrounds(true)"
          ></v-select>
        </v-flex>
        <v-flex xs6 md3>
          <v-select
            class="pa-0 ma-0 mt-2 ml-1"
            style="height: 30px"
            v-model="imageColor"
            :items="imageColors"
            item-text="title"
            item-value="query"
            @change="loadPixabayBackgrounds(true)"
          ></v-select>
        </v-flex>
        <v-flex xs6 md3>
          <v-select
            class="pa-0 ma-0 mt-2 ml-1"
            style="height: 30px"
            v-model="imageType"
            :items="imageTypes"
            item-text="title"
            item-value="query"
            @change="loadPixabayBackgrounds(true)"
          ></v-select>
        </v-flex>
        <v-flex xs6 md3>
          <v-select
            class="pa-0 ma-0 mt-2 ml-1"
            style="height: 30px"
            v-model="imageOrientation"
            :items="imageOrientations"
            item-text="title"
            item-value="query"
            @change="loadPixabayBackgrounds(true)"
          ></v-select>
        </v-flex>
      </v-card-title>
      <v-card-text class="pa-0">
        <v-container fluid>
          <v-layout row class="px-1 pt-2">
            <v-flex
              v-for="(item, index) in backgrounds"
              :key="index"
              :id="String(item.id)"
              xs6
              sm4
              lg3
              xl2
            >
              <v-card
                outlined
                class="mx-1 mb-2"
                style="background-color: #fcfcfc"
              >
                <v-card-text class="pa-0">
                  <v-img
                    :src="item.webformatURL"
                    class="ma-1 hover-item"
                    @click="selectedItem(item)"
                  >
                  </v-img>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions
        v-if="numOfBackgrounds > 0"
        :class="getTheme() == 'dark' ? '#505050--text' : '#505050--text'"
        :style="
          getTheme() == 'dark'
            ? 'background-color: whitesmoke; border-top: 1px solid lightgray;'
            : 'background-color: white; border-top: 1px solid lightgray;'
        "
        ><v-spacer></v-spacer>
        <v-btn
          small
          color="primary"
          outlined
          :disabled="page <= 1"
          fab
          @click="turnPage(-1)"
        >
          <v-icon medium>mdi-arrow-left</v-icon>
        </v-btn>
        <div class="mx-4">
          {{ $t("dataGridRowPage") }} {{ page }} / {{ numOfPages }}
        </div>
        <v-btn
          small
          color="primary"
          outlined
          :disabled="page >= numOfPages"
          fab
          @click="turnPage(1)"
        >
          <v-icon medium>mdi-arrow-right</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>

    <!-- PLEASE WAIT DIALOG -->
    <v-dialog
      v-model="dialogWait"
      persistent
      max-width="400"
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-card-title class="headline">{{
          $t("userNewOrderPleaseWaitTitle")
        }}</v-card-title>
        <v-card-text class="d-flex">
          <v-spacer></v-spacer>
          <v-progress-linear
            color="primary"
            height="10"
            indeterminate
          ></v-progress-linear>
          <v-spacer></v-spacer>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>

<script>
import { authenticate } from "pixabay-api";
const { searchImages } = authenticate("19231524-499fd6cda25eb884a94192f59");

export default {
  name: "dialog-background-image-selection",
  data() {
    return {
      pixabayLogo: require("@/assets/pixabayLogo.png"),
      backgrounds: [],
      search: "",
      page: 1,
      imageType: "all",
      imageOrientation: "all",
      imageCategory: "",
      imageColor: "",
      numOfBackgrounds: 0,
      numOfPages: 0,
      pageSize: 30,
      initSearch: true,
      pixabay: null,
      dialogWait: false,
      imageTypes: [
        {
          title: this.$t("dialogPixabayImageTypeAll"),
          query: "all",
        },
        {
          title: this.$t("dialogPixabayImageTypeImages"),
          query: "image",
        },
        {
          title: this.$t("dialogPixabayImageTypeIllustrations"),
          query: "illustration",
        },
        {
          title: this.$t("dialogPixabayImageTypeVectors"),
          query: "vector",
        },
      ],
      imageOrientations: [
        {
          title: this.$t("dialogPixabayImageOrientationAll"),
          query: "all",
        },
        {
          title: this.$t("dialogPixabayImageOrientationLandscape"),
          query: "horizontal",
        },
        {
          title: this.$t("dialogPixabayImageOrientationPortrait"),
          query: "vertical",
        },
      ],
      imageCategorys: [
        {
          title: this.$t("dialogPixabayImageCategoryAll"),
          query: "",
        },
        {
          title: this.$t("dialogPixabayImageCategoryBackgrounds"),
          query: "backgrounds",
        },
        {
          title: this.$t("dialogPixabayImageCategoryNature"),
          query: "nature",
        },
        {
          title: this.$t("dialogPixabayImageCategoryFeelings"),
          query: "feelings",
        },
        {
          title: this.$t("dialogPixabayImageCategoryAnimals"),
          query: "animals",
        },
        {
          title: this.$t("dialogPixabayImageCategoryFashion"),
          query: "fashion",
        },
        {
          title: this.$t("dialogPixabayImageCategoryMusic"),
          query: "music",
        },
        {
          title: this.$t("dialogPixabayImageCategorySports"),
          query: "sports",
        },
        {
          title: this.$t("dialogPixabayImageCategoryScience"),
          query: "science",
        },
        {
          title: this.$t("dialogPixabayImageCategoryEducation"),
          query: "education",
        },
        {
          title: this.$t("dialogPixabayImageCategoryHealth"),
          query: "health",
        },
        {
          title: this.$t("dialogPixabayImageCategoryPeople"),
          query: "people",
        },
        {
          title: this.$t("dialogPixabayImageCategoryReligion"),
          query: "religion",
        },
        {
          title: this.$t("dialogPixabayImageCategoryPlaces"),
          query: "places",
        },
        {
          title: this.$t("dialogPixabayImageCategoryIndustry"),
          query: "industry",
        },
        {
          title: this.$t("dialogPixabayImageCategoryComputer"),
          query: "computer",
        },
        {
          title: this.$t("dialogPixabayImageCategoryFood"),
          query: "food",
        },
        {
          title: this.$t("dialogPixabayImageCategoryTransportation"),
          query: "transportation",
        },
        {
          title: this.$t("dialogPixabayImageCategoryTravel"),
          query: "travel",
        },
        {
          title: this.$t("dialogPixabayImageCategoryBuildings"),
          query: "buildings",
        },
      ],
      imageColors: [
        {
          title: this.$t("dialogPixabayImageColorAll"),
          query: "",
        },
        {
          title: this.$t("dialogPixabayImageColorGrayscale"),
          query: "grayscale",
        },
        {
          title: this.$t("dialogPixabayImageColorRed"),
          query: "red",
        },
        {
          title: this.$t("dialogPixabayImageColorOrange"),
          query: "orange",
        },
        {
          title: this.$t("dialogPixabayImageColorYellow"),
          query: "yellow",
        },
        {
          title: this.$t("dialogPixabayImageColorGreen"),
          query: "green",
        },
        {
          title: this.$t("dialogPixabayImageColorTurquoise"),
          query: "turquoise",
        },
        {
          title: this.$t("dialogPixabayImageColorBlue"),
          query: "blue",
        },
        {
          title: this.$t("dialogPixabayImageColorLilac"),
          query: "lilac",
        },
        {
          title: this.$t("dialogPixabayImageColorPink"),
          query: "pink",
        },
        {
          title: this.$t("dialogPixabayImageColorWhite"),
          query: "white",
        },
        {
          title: this.$t("dialogPixabayImageColorGray"),
          query: "gray",
        },
        {
          title: this.$t("dialogPixabayImageColorBlack"),
          query: "black",
        },
        {
          title: this.$t("dialogPixabayImageColorBrown"),
          query: "brown",
        },
      ],
    };
  },
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    startPixabaySearch: {
      type: String,
      required: true,
    },
  },
  computed: {
    active: {
      get() {
        if (this.value && this.initSearch) {
          this.resetSearch();
        }
        return this.value;
      },
      set: function (value) {
        this.initSearch = true;
        this.$emit("input", value);
      },
    },
  },
  methods: {
    turnPage(num) {
      this.page += num;
      this.loadPixabayBackgrounds(false);
    },
    selectedItem(item) {
      if (this.startPixabaySearch == "seamless") {
        this.$emit("selectedItem", item.largeImageURL); // pattern velkost max 1280px
      } else this.$emit("selectedItem", item.fullHDURL); // velikost za background original = item.imageURL
    },
    async loadPixabayBackgrounds(freshPages) {
      let tSearch = this.search; // zapišemo prejšnjo vrednost, sicer jo izbriše na null, zakaj ne vem
      let rSearch =
        this.startPixabaySearch == ""
          ? this.search
          : this.startPixabaySearch + " " + this.search;

      this.dialogWait = true;
      if (freshPages) {
        this.page = 1;
      }
      this.pixabay = await searchImages(
        rSearch,
        {
          page: this.page,
          per_page: this.pageSize,
          image_type: this.imageType,
          orientation: this.imageOrientation,
          category: this.imageCategory,
          colors: this.imageColor,
        },
        false
      ).then((r) => {
        this.search = tSearch; // zapišemo prejšnjo vrednost, sicer jo izbriše na null, zakaj ne vem
        this.backgrounds = r.hits;
        this.numOfBackgrounds = r.totalHits;
        this.numOfPages = Math.round(this.numOfBackgrounds / this.pageSize);
        this.dialogWait = false;
      });
    },
    resetSearch() {
      if (this.initSearch) {
        this.initSearch = false;
      }
      this.search = "";
      this.loadPixabayBackgrounds(true);
    },
  },
};
</script>

<style scoped>
a {
  color: gray;
  text-decoration: none;
}
.hover-item {
  cursor: pointer;
}
</style>